/* ============================================================
   product.js — VariantSelects, ProductForm, ProductMedia, QuickView
   ============================================================ */

class VariantSelects extends HTMLElement {
  connectedCallback() {
    this.productJsonScript = document.getElementById('ProductJSON-' + this.dataset.section);
    if (this.productJsonScript) {
      try { this.product = JSON.parse(this.productJsonScript.textContent); } catch (e) { this.product = null; }
    }
    this.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.addEventListener('change', () => this.onChange());
    });
    this.onChange();
  }

  getSelectedOptions() {
    const options = [];
    this.querySelectorAll('fieldset').forEach((fs) => {
      const checked = fs.querySelector('input[type="radio"]:checked');
      options.push(checked ? checked.value : null);
    });
    return options;
  }

  findVariant() {
    if (!this.product) return null;
    const selected = this.getSelectedOptions();
    return this.product.variants.find((v) => {
      return v.options.every((opt, i) => opt === selected[i]);
    });
  }

  onChange() {
    const variant = this.findVariant();
    if (!variant) return;
    const wrapper = document.getElementById('ProductForm-' + this.dataset.section + '-wrapper');
    const form = wrapper ? wrapper.querySelector('form') : document.getElementById('ProductForm-' + this.dataset.section);
    if (form) {
      const idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = variant.id;
    }
    const priceEl = document.getElementById('ProductPrice-' + this.dataset.section);
    if (priceEl) {
      let html = `<span class="price-sale">${formatMoney(variant.price)}</span>`;
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html += `<span class="compare">${formatMoney(variant.compare_at_price)}</span>`;
      }
      priceEl.innerHTML = html;
    }
    const submitBtn = document.querySelector('#ProductForm-' + this.dataset.section + '-wrapper [type="submit"], #ProductForm-' + this.dataset.section + ' [type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = !variant.available;
      submitBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }
    if (variant.featured_image) {
      const main = document.querySelector('.product-gallery__main img');
      if (main) main.src = variant.featured_image.src;
    }
    history.replaceState({}, '', `?variant=${variant.id}`);
  }
}
customElements.define('variant-selects', VariantSelects);

/* Product media gallery thumbnails */
document.querySelectorAll('.product-gallery__thumb').forEach((thumb) => {
  thumb.addEventListener('click', () => {
    const src = thumb.dataset.full;
    const main = thumb.closest('.product-gallery').querySelector('.product-gallery__main img');
    if (main && src) main.src = src;
    thumb.closest('.product-gallery').querySelectorAll('.product-gallery__thumb').forEach((t) => t.classList.toggle('is-active', t === thumb));
  });
});

/* Quick view */
class QuickView extends HTMLElement {
  connectedCallback() {
    document.querySelectorAll('[data-quick-view]').forEach((btn) => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const handle = btn.dataset.quickView;
        await this.load(handle);
      });
    });
  }
  async load(handle) {
    try {
      const res = await fetch(`/products/${handle}.js`);
      const product = await res.json();
      const variant = product.variants[0];
      const panel = this.querySelector('.modal__panel');
      panel.innerHTML = `
        <button class="modal__close" data-modal-close>&times;</button>
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:24px">
          <div style="background:var(--color-cream);border-radius:14px;overflow:hidden"><img src="${product.featured_image}" alt="${product.title}"></div>
          <div>
            <h2>${product.title}</h2>
            <div style="font-size:1.4rem;color:var(--color-accent);font-weight:600;margin:12px 0">${formatMoney(variant.price)}</div>
            <p style="color:var(--color-muted)">${product.description.slice(0, 280)}...</p>
            <a href="/products/${product.handle}" class="btn btn-primary" style="margin-top:16px">View Full Details</a>
          </div>
        </div>`;
      this.open();
    } catch (err) { console.error('Quick view failed', err); }
  }
  open() { this.setAttribute('open', ''); document.body.style.overflow = 'hidden'; }
  close() { this.removeAttribute('open'); document.body.style.overflow = ''; }
}
customElements.define('quick-view', QuickView);
